export const RESUME_LINK = `${process.env.PUBLIC_URL}/Resume.pdf`;
